export default __webpack_public_path__ + "static/bg-glow-72e37e778d8b3c08d8d161d3d9c00989.png";